import Swiper, {Navigation, Pagination} from "swiper";
Swiper.use([Navigation, Pagination]);

const initCoachingReviewsSliders = () => {
  const slidersContainer = document.querySelector("[data-coaching-reviews-sliders]");
  if (!slidersContainer) return;

  const reviewsSliders = slidersContainer.querySelectorAll("[data-coaching-reviews-slider]");

  reviewsSliders.forEach(slider => {
    new Swiper(slider, {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      spaceBetween: 16,
      breakpoints: {
        1025: {
        slidesPerView: 3,
        },    
        768: {
          slidesPerView: 2,
        },       
        0: {
          slidesPerView: 1,
        },
      },
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true,
        bulletElement: "button",
      },
      navigation: {
        nextEl: slider.querySelector(".slider-navigation__button--next"),
        prevEl: slider.querySelector(".slider-navigation__button--prev"),
      },
    });
  })
};

export default initCoachingReviewsSliders;
